import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CurrentDeputatesTable } from '../../../../../components/Deputate/Tables/CurrentDeputatesTable';
import { Page } from '../../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../../hooks/usePermissionChecker';

export const DeputateEvaluateCurrentOverviewSubpage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  const handleRowClick = (teacherUuid: string) => navigate(`${t('routes.lessons.plan.teachers.slug')}/${teacherUuid}`);

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <CurrentDeputatesTable onRowClick={handleRowClick} />
    </Page>
  );
};
